module.exports = __webpack_public_path__ + "static/img/software4.fd4cdb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software4.jpg
// module id = dfD0
// module chunks = 2